import React, { useMemo } from "react";
import cx from "classnames";
import IconAlertPink from "assets/icons/iconAlertPink.svg";
import styles from "./Switch60Pods.module.scss";
import Button from "shared/Button";

const Switch60Pods = ({ onUpgradeClick, onDowngradeClick, subscriptions }) => {
  const upgradeEligibleSubscription = useMemo(
    () =>
      subscriptions.find(sub => {
        // Only allow upgrades for single-product subscriptions that have
        // a frequency of <= 6
        if (sub.products.length !== 1 || sub.interval > 6) {
          return false;
        }

        // Only allow it when there's only 1x pod letterbox
        const onlyProduct = sub.products[0];
        return onlyProduct.variant.sku?.startsWith("PODLB-");
      }),
    [subscriptions]
  );

  const revertEligibleSubscription = useMemo(
    () =>
      subscriptions.find(sub => {
        // Only allow downgrades for single-product subscriptions that have a
        // frequency of > 1
        if (sub.products.length !== 1 || sub.interval < 2) {
          return false;
        }

        // Only allow it when there's only 1x 60 pod box
        const onlyProduct = sub.products[0];
        console.log("PRoduct: ", onlyProduct);
        return onlyProduct.variant.sku?.startsWith("60PODLB-");
      }),
    [subscriptions]
  );

  if (revertEligibleSubscription) {
    return (
      <div
        className={cx(styles.container, "mt-3")}
        onClick={() => onDowngradeClick(revertEligibleSubscription)}
        role="button"
      >
        <div className="d-flex align-items-center">
          <img alt="Important update" className="me-2" src={IconAlertPink} />
          <p className="gkit-p-15 fw-medium">
            Your subscription has been updated, reducing the number of
            deliveries you receive - saving you money & reducing the impact on
            the planet. <u>Find out more</u>
          </p>
        </div>
      </div>
    );
  }

  if (upgradeEligibleSubscription) {
    return (
      <div
        className={cx(styles.container, "mt-3")}
        onClick={() => onUpgradeClick(upgradeEligibleSubscription)}
        role="button"
      >
        <div className="d-flex align-items-center">
          <img alt="Important update" className="me-2" src={IconAlertPink} />
          <div>
            <p className="gkit-p-15 fw-medium">
              Save money (and the planet!) by upgrading to our 60-pod box
              subscription. Fewer deliveries = better value for you.
            </p>
            <Button className="mt-2" size="xs">
              Update now
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default Switch60Pods;
